// Components
const ClientHeader = () => import(/* webpackPrefetch: true, webpackChunkName: "client-header" */ '@/app/views/client-view/_shared/client-header/client-header.vue');
const TheFooter = () => import(/* webpackPrefetch: true, webpackChunkName: "the-footer" */ '@/app/views/main-view/_shared/the-footer/the-footer.vue');
const PuppyForSaleDetails = () => import(/* webpackPrefetch: true, webpackChunkName: "puppy-for-sale-details" */ '@/app/views/client-view/puppy-for-sale-page/components/puppy-for-sale-details/puppy-for-sale-details.vue');

// Mixins
import { googleTagManagerMixins } from '@/app/mixins/utils/google-tag-manager-mixins';

export default {
    name: 'PuppyForSaleDetailsContainer',
    mixins: [ googleTagManagerMixins ],
    components: {
        ClientHeader,
        TheFooter,
        PuppyForSaleDetails,
    },
    computed: {
        isNativeApp() {
            return this.$store.getters.getIsNativeApp;
        },
    },
    data() {
        return {
            hasLatitudePay: false,
            showMainLogo: true
        };
    },
}